"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SparkThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_3299_81237)" },
            react_1.default.createElement("path", { d: "M9.5 5L12 5L12 6.5L9.5 6.5L9.5 5Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M-0.000488281 5L2.49951 5L2.49951 6.5L-0.000488281 6.5L-0.000488281 5Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M9.00488 7.69482L10.7726 9.46259L9.71199 10.5233L7.94422 8.75548L9.00488 7.69482Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M2.28711 0.977051L4.05488 2.74482L2.99422 3.80548L1.22645 2.03771L2.28711 0.977051Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M6.74951 9.49902L6.74951 11.999L5.24951 11.999L5.24951 9.49902L6.74951 9.49902Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M6.74951 -0.000976562L6.74951 2.49902L5.24951 2.49902L5.24951 -0.000976563L6.74951 -0.000976562Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M4.05469 8.75488L2.28692 10.5226L1.22626 9.46199L2.99403 7.69422L4.05469 8.75488Z", fill: "#D8DADE" }),
            react_1.default.createElement("path", { d: "M10.7725 2.03711L9.00469 3.80488L7.94403 2.74422L9.7118 0.976449L10.7725 2.03711Z", fill: "#D8DADE" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_3299_81237" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white" }))));
}
function SparkThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SparkThin12Svg, Object.assign({}, svgProps)));
}
exports.default = SparkThin12;
//# sourceMappingURL=SparkThin12.js.map